import { render, staticRenderFns } from "./WPDatepicker.vue?vue&type=template&id=92c8d6a2"
import script from "./WPDatepicker.vue?vue&type=script&lang=ts"
export * from "./WPDatepicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports